<div class="flex search-section justify-content-between" [ngStyle]="{ width }">
  <div class="input-group has-search search-box">
    <img src="content/images/icons/search.svg" width="16" height="16" class="form-control-feedback search-icon" alt="search">
    <input type="text" class="form-control search-bar light-blue-border input-bg-color" placeholder="Search" [(ngModel)]="text" (ngModelChange)="this.textChange.emit(text)" data-test="search-bar-input">
  </div>
</div>
